let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j4nUA")).then(() => parcelRequire('f9UJM'));